import React from 'react';
import PropTypes from 'prop-types';

import styles from './block/block.module.scss';

export const BlockRemove = ({ onRemoveClick = () => {} }) => {
  return (
    <button className={`btn-cross ${styles.remove}`} onClick={onRemoveClick} />
  );
};

export const Block = ({ className = '', children }) => (
  <div className={`${styles.block} ${className}`}>
    {children}
  </div>
);

export class ParamsBlock extends React.Component {
  state = {
    isActive: false,
  }

  handleOnClick = () => {
    const { onClick } = this.props;
    const { isActive } = this.state;
    this.setState({ isActive: !isActive });
    if (onClick) {
      onClick();
    }
  }

  render() {
    const { className = '', title, list } = this.props;
    const { isActive } = this.state;

    return (
      <div
        className={`${styles.paramsBlock} ${isActive ? '_active' : ''} ${className}`}
        onClick={this.handleOnClick}
      >
        <header className={styles.paramsBlockHeader}>
          <h4 className={styles.paramsBlockTitle}>
            {title}
          </h4>
        </header>
        <ul className={styles.paramsBlockList}>
          {list.map(i => (
            <li
              className={styles.paramsBlockItem}
              key={i.label}
              style={{minWidth: `100 / ${list.length}%`}}
            >
              <span className={styles.paramsBlockLabel}>
                {i.label}
              </span>
              <span className={styles.paramsBlockValue}>
                {i.value}
              </span>
            </li>
          ))}
        </ul>
      </div>
    )
  }
}

export const DateBlock = ({className = '', date}) => {
  return (
    <div className={`${styles.dateBlock} ${className}`}>
      <span className={styles.dateBlockValue}>
        {date}
      </span>
    </div>
  );
};

Block.propTypes = {
  className: PropTypes.string,
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.element), PropTypes.element])
};

BlockRemove.propTypes = {
  onRemoveClick: PropTypes.func,
};

ParamsBlock.propTypes = {
  className: PropTypes.string,
  title: PropTypes.string.isRequired,
  list: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string,
      value: PropTypes.string,
    })
  ).isRequired,
  onClick: PropTypes.func,
};

DateBlock.propTypes = {
  className: PropTypes.string,
  date: PropTypes.string,
};
